export default (function (user) {
    /** @note Added optional chaining to prevent error if `user` doesn't exist (bad data) */
    var firstname = (user === null || user === void 0 ? void 0 : user.firstName) || (user === null || user === void 0 ? void 0 : user.firstname);
    var lastname = (user === null || user === void 0 ? void 0 : user.lastName) || (user === null || user === void 0 ? void 0 : user.lastname);
    return "" + firstname + (lastname ? " " + lastname : "");
});
